import styles from './CadastrarFuncionarioPopUp.module.css';
import { useState } from 'react';
import Input from '../form/Input';

function CadastrarFuncionarioPopUp({ onClose, onCadastroSucesso }) {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [tipoUsuario, setTipoUsuario] = useState('atendente');
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const cadastroFuncionario = async (e) => {
    e.preventDefault();

    if (!nome || !email || !telefone) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    setLoading(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const estabelecimento_id = localStorage.getItem("estabelecimento_id");
      const id_administrador = localStorage.getItem("admin_id");

      if (!estabelecimento_id || !id_administrador) {
        alert("Erro: Estabelecimento ou administrador não identificado. Por favor, faça login novamente.");
        setLoading(false);
        return;
      }

      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/cadastrogarcons`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          nome,
          telefone,
          email,
          tipo_usuario: tipoUsuario,
          id_administrador,
          estabelecimento_id
        })
      });

      if (response.ok) {
        setLoading(false);
        setSucesso(true);

        // Chamar callback para atualizar a lista
        if (onCadastroSucesso) {
          onCadastroSucesso();
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error("Erro ao cadastrar o funcionário:", errorData);
        setLoading(false);
        alert(errorData.error || "Erro ao cadastrar o funcionário. Tente novamente.");
      }
    } catch (err) {
      console.error("Erro na requisição:", err);
      setLoading(false);
      alert("Erro ao cadastrar o funcionário. Tente novamente.");
    }
  };

  const fecharSucesso = () => {
    setSucesso(false);
    setNome('');
    setEmail('');
    setTelefone('');
    setTipoUsuario('atendente');
    onClose();
  };

  if (sucesso) {
    return (
      <div className={styles.containerCadastro}>
        <div className={styles.sucessoContainer}>
          <div className={styles.sucessoIcone}>✓</div>
          <h2 className={styles.sucessoTitulo}>Cadastro Realizado!</h2>
          <p className={styles.sucessoMensagem}>
            O funcionário foi cadastrado com sucesso.
          </p>
          <p className={styles.sucessoMensagem}>
            Um email de ativação será enviado para <strong>{email}</strong> com as instruções para criar a senha e acessar o sistema.
          </p>
          <button className={styles.btn} onClick={fecharSucesso}>
            Fechar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.containerCadastro}>
      <div className={styles.headerCadastro}>
        <h2>Cadastrar Novo Membro da Equipe</h2>
        <p className={styles.subtitulo}>Preencha os dados abaixo para adicionar um novo membro à equipe</p>
      </div>

      <form className={styles.formCadastro} onSubmit={cadastroFuncionario}>
        <Input
          type="text"
          text="Nome Completo"
          name="nome"
          placeholder="Digite o nome completo"
          value={nome}
          handleOnChange={(e) => setNome(e.target.value)}
          disabled={loading}
        />

        <Input
          type="email"
          text="Email"
          name="email"
          placeholder="Digite o email"
          value={email}
          handleOnChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />

        <Input
          type="text"
          text="Telefone"
          name="telefone"
          placeholder="(00) 00000-0000"
          value={telefone}
          handleOnChange={(e) => setTelefone(e.target.value)}
          disabled={loading}
        />

        <label className={styles.labelSelect} htmlFor="tipoUsuario">Função</label>
        <select
          id="tipoUsuario"
          className={styles.selectFuncao}
          value={tipoUsuario}
          onChange={(e) => setTipoUsuario(e.target.value)}
          disabled={loading}
        >
          <option value="atendente">Atendente</option>
          <option value="cozinha">Cozinha</option>
          <option value="entregador">Entregador</option>
        </select>

        <button className={styles.btn} type="submit" disabled={loading}>
          {loading ? 'Cadastrando...' : 'Cadastrar Funcionário'}
        </button>
      </form>
    </div>
  );
}

export default CadastrarFuncionarioPopUp;
